module.exports = __webpack_public_path__ + "static/media/CapacityBuildingSidebar.b610fe82.svg";